import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { PuntoControlService } from './puntocontrol.service';
import { AutoridadControlViewModel } from './puntocontrol.types';
import { DatePipe } from '@angular/common';
import { OnInit } from '@angular/core';
import { Tc } from '../../../core/_infrastructure/types/common';
import { NoWhiteSpaceValidator } from '../../../core/_infrastructure/classes/noWhiteSpaceValidator';

@Component({
    selector: 'app-autoridadcontrol-edit',
    templateUrl: './autoridadcontrol-edit.component.html',
})
export class AutoridadControlEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nueva';
    autoridadControl: AutoridadControlViewModel;
    visibilitySpinner = false;
    isCollapsedAutoridad = false;
    IdAutoridadControl: number;
    IdPuntoControl: number;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificationService: NotificationService,
        private puntoControlService: PuntoControlService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.autoridadControl = new AutoridadControlViewModel();
    }

    ngOnInit() {
        this.createForm();

        let idPuntoControl = +this.activatedRoute.snapshot.params['id'];
        let idAutoridadControl = +this.activatedRoute.snapshot.params['idautoridad'];

        this.IdPuntoControl = idPuntoControl;
        this.IdAutoridadControl = idAutoridadControl;

        //EDIT
        if (idAutoridadControl) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.puntoControlService.getAutoridadControl(idAutoridadControl).subscribe(result => {
                this.autoridadControl = result;
                this.updateForm();
            });
        }
        //ALTA
        else {
            //En el alta se graba activa por defecto
            this.form.controls['Activa'].disable();
        }
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.compose([Validators.required, NoWhiteSpaceValidator.cannotContainSpace])],
            ReferenciaTraces: ['', Validators.compose([Validators.required, NoWhiteSpaceValidator.cannotContainSpace])],
            Activa: true,
            Direccion: '',
            Ciudad: '',
            CodigoPostal: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.autoridadControl.Descripcion,
            ReferenciaTraces: this.autoridadControl.ReferenciaTraces,
            Activa: this.autoridadControl.Activa,
            Direccion: this.autoridadControl.Direccion,
            Ciudad: this.autoridadControl.Ciudad,
            CodigoPostal: this.autoridadControl.CodigoPostal,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedAutoridad = false;
            return;
        }

        this.visibilitySpinner = true;

        let autoridadControl = new AutoridadControlViewModel();

        if (this.IdAutoridadControl) {
            autoridadControl.Id = this.IdAutoridadControl;
            autoridadControl.Activa = this.form.value.Activa; //Solo lleva valor en el EDIT, en el insert se guarda como Activa en el service
        } else {
            autoridadControl.Id = 0;
            autoridadControl.Activa = true; //Solo lleva valor en el EDIT, en el insert se guarda como Activa en el service
        }

        autoridadControl.IdPuntoControl = this.IdPuntoControl;

        autoridadControl.Descripcion = this.form.value.Descripcion;
        autoridadControl.ReferenciaTraces = this.form.value.ReferenciaTraces;
        autoridadControl.Direccion = this.form.value.Direccion;
        autoridadControl.Ciudad = this.form.value.Ciudad;
        autoridadControl.CodigoPostal = this.form.value.CodigoPostal;

        if (this.editMode) {
            this.puntoControlService.editAutoridadControl(autoridadControl).subscribe({
                next: () => {
                    this.addSuccessMessage('Autoridad de control modificada correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedAutoridad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedAutoridad = false;
                },
            });
        } else {
            this.puntoControlService.addAutoridadControl(autoridadControl).subscribe({
                next: () => {
                    this.addSuccessMessage('Autoridad de control añadida correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/puntoscontrol/edit', this.IdPuntoControl]);
    }
}
